
import BaseModel from './BaseModel';
export default class RateCompare extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data);
    }

    setData(data = this.__data__) {
        this.createdBy = data.createdBy || '';
        this.createdDate = data.createdDate || '';
        this.deletedDate = data.deletedDate || '';
        this.hotelId = data.hotelId || '';
        this.id = data.id || '';
        this.isDeleted = data.isDeleted;
        this.modifiedBy = data.modifiedBy || '';
        this.modifiedDate = data.modifiedDate || '';
        this.note = data.note || '';
        this.rateCodeCompare = data.rateCodeCompare || '';
        this.rateCodePriority = data.rateCodePriority || '';
    }
}
